import { createRelayResource } from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';
import UI_ORGANIZATION_DETAILS_PAGE_QUERY, {
	type uiOrganizationDetailsPageQuery,
} from '@atlassian/jira-relay/src/__generated__/uiOrganizationDetailsPageQuery.graphql';

export const uiOrganizationDetailsPageQueryResource =
	createRelayResource<uiOrganizationDetailsPageQuery>({
		type: 'UI_ORGANIZATION_DETAILS_PAGE_QUERY',
		getQuery: ({ match }, { tenantContext }) => ({
			parameters: UI_ORGANIZATION_DETAILS_PAGE_QUERY,
			variables: {
				organizationId: String(match.params.organizationId),
				cloudId: tenantContext.cloudId,
			},
			options: { fetchPolicy: 'store-and-network' },
		}),
	});
